<script>
export default {
  name: "ybutton",
  functional: true,
  /**
   * 属性跟element按钮一样
   * element-ui: https://element.eleme.cn/#/zh-CN/component/button
   */
  props: {
    //朴素按钮
    plain: {
      type: Boolean,
      default: false,
    },
    // 是否加载中状态
    loading: {
      type: Boolean,
      default: false,
    },
    //尺寸
    size: {
      type: String,
      default: "small",
    },
    // 是否圆角按钮
    round: {
      type: Boolean,
      default: false,
    },
    //是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    //按钮类型
    icon: {
      type: String,
      default: "",
    },
    prower: {
      type: String,
      default: "",
    },
    //按钮类型
    type: {
      type: String,
      default: "",
    },
    //按钮标题
    title: {
      type: String,
      default: "",
    },
    //按钮点击事件
    buttonOnclick: {
      type: Function,
      default: () => {},
    },
  },
  //渲染按钮
  render(h, context) {
    const {
      icon,
      type,
      title,
      disabled,
      size,
      plain,
      loading,
      round,
      prower,
      buttonOnclick,
    } = context.props;
    return [
      <el-button
        type={type}
        plain={plain}
        loading={loading}
        size={size}
        round={round}
        disabled={disabled}
        icon={icon}
        on-click={buttonOnclick}
      >
        {title}
      </el-button>,
    ];
  },
};
</script>

<style lang="scss" scoped>
.el-button {
  min-width: 24px;
  height: 30px;
  padding: 0 20px !important;
  text-align: center;
  line-height: 30px !important;
  font-size: 12px !important;
}
.el-button--text {
  padding: 0 !important;
  font-size: 12px !important;
}
.el-button--primary.is-disabled {
  background-color: #aacfff;
  border: none !important;
}
</style>
